import { render, staticRenderFns } from "./sectionlist.vue?vue&type=template&id=7f62ff7c&scoped=true&"
import script from "./sectionlist.vue?vue&type=script&lang=js&"
export * from "./sectionlist.vue?vue&type=script&lang=js&"
import style0 from "./sectionlist.vue?vue&type=style&index=0&id=7f62ff7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f62ff7c",
  null
  
)

export default component.exports